import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'ligature',
  size: 24,
  node: [
    ['path', { d: 'M14 12h2v8', key: 'c1fccl' }],
    ['path', { d: 'M14 20h4', key: 'lzx1xo' }],
    ['path', { d: 'M6 12h4', key: 'a4o3ry' }],
    ['path', { d: 'M6 20h4', key: '1i6q5t' }],
    ['path', { d: 'M8 20V8a4 4 0 0 1 7.464-2', key: 'wk9t6r' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Ligature
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMTJoMnY4IiAvPgogIDxwYXRoIGQ9Ik0xNCAyMGg0IiAvPgogIDxwYXRoIGQ9Ik02IDEyaDQiIC8+CiAgPHBhdGggZD0iTTYgMjBoNCIgLz4KICA8cGF0aCBkPSJNOCAyMFY4YTQgNCAwIDAgMSA3LjQ2NC0yIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/ligature
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Ligature = createLucideIcon(__iconData);

export default Ligature;
